import { React, useState, useRef } from "react";
import "./PrivateLimitedCompany.css";
import ContactPopup from "./ContactPopup";


const PrivateLimitedCompany = () => {
    const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }


    return (
        <div className="page">

            {/* HERO */}
            <div className="hero">

                <h1>Private Limited Company</h1>

                <p className="subtitle">
                    Fast, Affordable & Hassle-Free Company Registration
                </p>

                <p className="desc">
                    We help entrepreneurs, startups, and growing businesses register their Private Limited Company quickly and legally. From documentation to approval, our experts handle everything so you can focus on building your business.
                </p>

                <div className="badges">
                    <span>✔ 100% Online Process</span>
                    <span>✔ Expert Guidance</span>
                    <span>✔ Quick Turnaround</span>
                    <span>✔ Transparent Pricing</span>
                </div>

                {/* BUTTON FIXED AT BOTTOM */}
                <div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>

            </div>


            {/* ABOUT */}
            <Section title="About the Service">
                <h3>What is a Private Limited Company?</h3>
                <p>
                    A Private Limited Company is one of the most popular business structures for startups and growing businesses. It offers limited liability protection to its shareholders and has a separate legal identity from its owners.
                </p>
            </Section>

            {/* WHY CHOOSE */}
            <Section title="Why Choose a Private Limited Company?">
                <ul>
                    <li>Limited liability protection</li>
                    <li>Separate legal entity</li>
                    <li>Easy to raise funding</li>
                    <li>Improved credibility and trust</li>
                    <li>Perpetual succession</li>
                    <li>Ownership transfer flexibility</li>
                </ul>
            </Section>

            {/* SERVICES */}
            <Section title="Our Services Include">
                <p>We provide end-to-end company registration services:</p>
                <ul>
                    <li>Name Approval (RUN/Name Reservation)</li>
                    <li>Digital Signature Certificate (DSC)</li>
                    <li>Director Identification Number (DIN)</li>
                    <li>MOA & AOA Drafting</li>
                    <li>Company Incorporation Certificate</li>
                    <li>PAN & TAN Application</li>
                    <li>Bank Account Assistance</li>
                </ul>
            </Section>

            {/* DOCUMENTS */}
            <Section title="Documents Required">

                <h3>For Directors/Shareholders:</h3>
                <ul>
                    <li>PAN Card</li>
                    <li>Aadhaar Card / Passport / Voter ID</li>
                    <li>Passport-size Photograph</li>
                    <li>Address Proof (Bank Statement / Utility Bill)</li>
                </ul>

                <h3>For Registered Office:</h3>
                <ul>
                    <li>Rent Agreement (if rented)</li>
                    <li>NOC from Owner</li>
                    <li>Utility Bill (Electricity/Water)</li>
                </ul>

            </Section>

            {/* PROCESS */}
            <Section title="Simple Registration Process">
                <ul>
                    <li>Consultation – Share your business details</li>
                    <li>Document Collection – Submit required documents</li>
                    <li>Name Approval – Choose and reserve company name</li>
                    <li>Filing & Submission – We handle government filings</li>
                    <li>Company Approval – Get your incorporation certificate</li>
                </ul>
            </Section>

            {/* PRICING */}
            <Section title="Pricing Plans">

                <div className="grid">

                    <div className="card blue">
                        <h3>Basic Plan</h3>
                        <ul>
                            <li>Company Registration</li>
                            <li>PAN & TAN</li>
                            <li>Digital Signatures</li>
                            <li>Ideal for startups</li>
                        </ul>
                    </div>

                    <div className="card purple">
                        <h3>Standard Plan</h3>
                        <ul>
                            <li>Everything in Basic</li>
                            <li>GST Registration</li>
                            <li>Bank Account Support</li>
                        </ul>
                    </div>

                    <div className="card orange">
                        <h3>Premium Plan</h3>
                        <ul>
                            <li>Everything in Standard</li>
                            <li>Compliance Support</li>
                            <li>Business Consultation</li>
                        </ul>
                    </div>

                </div>

            </Section>

            {/* WHY US */}
            <Section title="Why Choose Us?">
                <ul>
                    <li>Experienced Professionals</li>
                    <li>Affordable Pricing</li>
                    <li>Quick Processing</li>
                    <li>Dedicated Support</li>
                    <li>No Hidden Charges</li>
                </ul>
            </Section>

            {/* FAQ */}
            <Section title="FAQs">
                <p><b>How long does it take to register a company?</b> Usually 5–10 working days, depending on approvals.</p>
                <p><b>How many directors are required?</b> Minimum 2 directors are required.</p>
                <p><b>Is physical presence required?</b> No, the entire process is online.</p>
                <p><b>Can NRIs register a company?</b> Yes, NRIs and foreign nationals can be directors.</p>
            </Section>

            {/* CTA */}
            <div className="cta" ref={contactRef}>
                <h2>Ready to Start Your Business?</h2>
                <p>
                    Register your Private Limited Company today with ease.
                </p>

                <div className="cta-buttons">
                    <button onClick={() => setOpenPopup(true)}
                    >Contact Us Now</button>
                    <ContactPopup
                        isOpen={openPopup}
                        onClose={() => setOpenPopup(false)}
                    />

                    <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
                    >Get Free Consultation</button>
                </div>
            </div>

        </div>
    );
};

const Section = ({ title, children }) => (
    <div className="section">
        <h2>{title}</h2>
        {children}
    </div>
);

export default PrivateLimitedCompany;